import HiredLogo from "@/components/brand/HiredLogo";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="border-t border-line mt-24">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-14 grid grid-cols-2 md:grid-cols-4 gap-8">
        <div className="col-span-2">
          <HiredLogo size={22} />
          <p className="text-steel mt-6 text-sm max-w-sm leading-relaxed">
            Build AI employees that handle the work, so you can focus on what matters.
          </p>
          <p className="mt-6 text-xs tracking-[0.28em] uppercase text-steel">
            Your next employee <span className="text-purple">isn&apos;t human.</span>
          </p>
        </div>
        <div>
          <div className="brand-eyebrow mb-4">Platform</div>
          <ul className="space-y-2 text-steel text-sm">
            <li><Link to="/hired/hoa-steward" className="hover:text-ivory">HOA Steward</Link></li>
            <li><Link to="/hired/homihq" className="hover:text-ivory">HomiHQ</Link></li>
            <li><Link to="/hired/foundation-first" className="hover:text-ivory">Foundation First</Link></li>
          </ul>
        </div>
        <div>
          <div className="brand-eyebrow mb-4">Company</div>
          <ul className="space-y-2 text-steel text-sm">
            <li><Link to="/pricing" className="hover:text-ivory">Pricing</Link></li>
            <li><Link to="/about" className="hover:text-ivory">About</Link></li>
            <li><Link to="/contact" className="hover:text-ivory">Contact</Link></li>
            <li><Link to="/login" className="hover:text-ivory">Log in</Link></li>
          </ul>
          <div className="brand-eyebrow mt-6 mb-4">Legal</div>
          <ul className="space-y-2 text-steel text-sm">
            <li><Link to="/privacy" data-testid="footer-privacy" className="hover:text-ivory">Privacy Policy</Link></li>
            <li><Link to="/terms" data-testid="footer-terms" className="hover:text-ivory">Terms of Service</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-line py-6 text-center text-xs text-steel tracking-widest">
        © {new Date().getFullYear()} HIRED — YOUR NEXT EMPLOYEE <span className="text-purple">ISN&apos;T HUMAN.</span>
      </div>
    </footer>
  );
}
